import { Suspense, useEffect } from "react";
import "./App.css";
import React from "react";
import { useStateContext } from "./context/ContextProvider.js";
import { useTranslation } from "react-i18next";
import Store from "./redux/store.js";
import { ToastContainer } from "react-toastify";
import { loadUser } from "./redux/actions/user.js";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProtectedAdminRoute from "./routers/ProtectedAdminRoute.js"
import {AdminRouters} from "./routers/AdminRouters.js"
import {
  Home,
  MealDetails,
  AllMeals,

  AboutUs,
  Login,
  SignUp,
  OtpVerification,



  MealsCategories,
  ResetVerification,
  ForgetPassword,
  ResetPassword,
  AllFeaturedMeals,
  FeaturedMealDetails
} from "./pages";


import AllResturentMeals from "./pages/allResturentMeals.jsx";

function App() {
  const {
    setCurrentLang,
    currentLang,
    setCurrentDir,
    currentDir,
    setDir,
    setMode,
    currentMode,
  } = useStateContext();
  const { i18n } = useTranslation();
  useEffect(() => {
    const currentThemeMode = localStorage.getItem("themeMode");
    if (currentThemeMode) {
      setMode(currentThemeMode);
    }
  }, []);
  useEffect(() => {
    const currentThemedir = localStorage.getItem("themeDir");
    const currentThemelang = localStorage.getItem("themeLang");
    if (currentThemedir && currentThemelang) {
      setCurrentDir(currentThemedir);
      setCurrentLang(currentThemelang);
    }
    i18n.changeLanguage(currentLang);
  }, [currentLang]);
  useEffect(() => {
    Store.dispatch(loadUser());
  }, []);
  return (
    <div
      className={currentMode === "Dark" ? "dark" : ""}
      dir={currentDir === "rtl" ? "rtl" : "ltr"}
    >
      <Suspense fullback={null}>
        <div className="bg-back-secondary dark:bg-back-darkprimery">
          {" "}
          <BrowserRouter>
            {/*<div className="pt-[4rem] lg:pt-[5rem]  overflow-hidden">*/}

            <Routes>
          
      

           {AdminRouters.map((route, index) => {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={       <ProtectedAdminRoute>{route.element }  </ProtectedAdminRoute>}
                  />
                );
              }
          )}
            
              
          











              <Route path="/" element={<Home />} />
   
              <Route path="/AllMeals" element={<AllMeals />} />
              <Route path="/AllResturentMeals" element={<AllResturentMeals />} />
              <Route path="/MealsCategories" element={<MealsCategories />} />
              <Route path="/MealDetails/:id" element={<MealDetails />} />
              <Route path="AllFeaturedMeals" element={<AllFeaturedMeals />} />
              <Route path="/FeaturedMealDetails/:id" element={<FeaturedMealDetails />} />

          
              <Route path="/AboutUs" element={<AboutUs />} />
         
              <Route path="/Login" element={<Login />} />
              <Route path="/ForgetPassword" element={<ForgetPassword />} />
              <Route path="/ResetPassword" element={<ResetPassword />} />
              <Route path="/ResetVerification" element={<ResetVerification />} />
              <Route path="/OtpVerification" element={<OtpVerification />} />.
            </Routes>
            <ToastContainer
              className=" fixed tostt z-[10000000]"
              position={currentDir === "rtl" ? "top-left" : "top-right"}
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={currentDir === "rtl" ? true : false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme={currentMode === "Dark" ? "dark" : "light"}
            />
          </BrowserRouter>
        </div>
      </Suspense>
    </div>
  );
}

export default App;
